export default {
      id: "present-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.svg#present",
      toString: function () {
        return this.url;
      }
    }